import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Cookie from 'js-cookie';
import { setCurrentUserAction } from '../users/Actions';
import {
  signupAdminSuccessAction,
  signupArtisanSuccessAction,
  signupSupplierSuccessAction,
  setAuthIsLoadingAction,
  loginUserSuccessAction,
  logoutUserSuccessAction,
  logoutUserAction,
  forgotPasswordAction,
  forgotPasswordSuccessAction,
  signupCustomerSuccessAction,
  setUserProfiles,
  updateAuthArtisanSuccessAction,
  updateAuthCustomerSuccessAction,
  updateAuthSupplierSuccessAction,
  updateCurrentUserSuccessAction,
  updateCurrentUserSettingsSuccessAction
} from './Actions';

import { actions as globalActions } from '../../services/globalActions';

import {
  newSuccessNotificationAction,
  newErrorNotificationAction,
  errorNotificationFromError
} from '../notifications/Actions';

import * as api from './Api';
import { actions } from './Reducer';
import { set } from 'lodash';
import { typeOf } from 'react-is';

/**
 * To Do
 * - Delete All Success Action for sign up
 * - redirect the user to login page after sign up success
 *  */

function* signupAdmin({ payload, redirect }) {
  console.log({ payload });
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.SignupAdmin, payload);
    console.log({ response });
    const { data } = response;
    yield put(signupAdminSuccessAction(data.message));

    // redirect after signup Success
    !redirect ? yield put(push('/auth/login')) : yield put(push('/users'));

    yield put(
      newSuccessNotificationAction('Successfully SignUp Admin Account')
    );
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* signupArtisan({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.SingupArtisan, payload);
    console.log(response);
    const { data } = response;
    yield put(signupArtisanSuccessAction(data.message));

    // redirect after signup Success

    yield put(push('/auth/login'));

    yield put(
      newSuccessNotificationAction('Successfully SignUp Artisan Account')
    );
  } catch (error) {
    newErrorNotificationAction(error);
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* signupSupplier({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.SignupSupplier, payload);
    const { data } = response;
    yield put(signupSupplierSuccessAction(data.message));

    // redirect after signup Success

    yield put(push('/auth/login'));
    yield put(
      newSuccessNotificationAction('Successfully SignUp Supplier Acount')
    );
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* signupCustomer({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.SingupCutomer, payload);
    const { data } = response;
    yield put(signupCustomerSuccessAction(data.message));

    // redirect after signup Success

    yield put(push('/auth/login'));
    yield put(
      newSuccessNotificationAction('Successfully SignUp Customer Account')
    );
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* forgotPassword({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.forgotPassword, payload);
    const { data } = response;
    yield put(forgotPasswordSuccessAction(data.success));
    yield put(push('/auth/login'));
    yield put(newSuccessNotificationAction('Success'));
  } catch (error) {
    yield put(errorNotificationFromError('Invalid Email'));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* resetPassword({ payload }) {
  const { token, password } = payload;
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.resetPassword, token, password);
    yield put(newSuccessNotificationAction('Success'));
    yield put(push('/auth/login'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* loginUser({ payload, expiretionDate }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.Login, payload);
    const { data } = response;
    const user = data.user.userData;
    const artisanData = data.user.userData?.profiles.artisan;
    const supplierData = data.user.userData?.profiles.supplier;
    const customerData = data.user.userData?.profiles.customer;
    const applicantData = data.user.userData?.profiles.applicant;
    const userDefaultType = data.user.userData?.defaultUserType;
    console.log(data.user.UserData?.defaultUserType);
    const profiles = {
      artisanData,
      supplierData,
      customerData,
      applicantData
    };
    yield put(setUserProfiles(profiles));
    yield put(
      setCurrentUserAction({
        ...user,
        profiles: {
          artisan: profiles.artisanData,
          supplier: profiles.supplierData,
          customoer: profiles.customerData,
          applicant: profiles.applicantData
        }
      })
    );
    const { access_token: accessToken } = data;
    yield localStorage.setItem('profiles', JSON.stringify(profiles));
    // const updateUserType = yield call(userApi.updateUser, user._id, {defaultUserType: '3'})
    yield localStorage.setItem('defaultType', userDefaultType);
    // const number = localStorage.getItem('defaultType');
    // console.log(typeof number)
    Cookie.set('TOKEN', accessToken, { expires: expiretionDate });
    yield put(loginUserSuccessAction(user, accessToken));
    yield put(newSuccessNotificationAction('Successfully logged in'));
    // window.location.href = '/dashboard'
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* updateUserSettings({ payload: { id: values } }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(
      api.updateUserSettings,
      values.userId,
      values.values
    );
    console.log(response);
    const updatedUser = response;
    const { data } = updatedUser;
    yield put(updateCurrentUserSettingsSuccessAction(data));
    yield put(newSuccessNotificationAction(`Updated User `));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* updateUser({ payload }) {
  const { id, formData } = payload;
  try {
    yield put(setAuthIsLoadingAction(true));
    const response = yield call(api.updateUser, id, formData);
    console.log(response);
    const updatedUser = response;
    const { data } = updatedUser;
    yield put(updateCurrentUserSettingsSuccessAction(data));
    yield put(newSuccessNotificationAction(`Updated User `));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* logoutUser() {
  try {
    yield localStorage.removeItem('profiles');
    yield Cookie.remove('TOKEN');
    yield localStorage.removeItem('userTypeNum');
    yield localStorage.removeItem('defaultType');
    yield put(logoutUserSuccessAction());
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(newSuccessNotificationAction('Goodbye!'));
  }
}

function* updateAuthArtisan({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const respone = yield call(api.updateAuthArtisan, payload);
    // yield put(updateAuthArtisanSuccessAction)
    yield put(newSuccessNotificationAction('Artisan Updated! Pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* updateAuthSupplier({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const respone = yield call(api.updateAuthSupplier, payload);
    // yield put(updateAuthSupplierSuccessAction)
    yield put(newSuccessNotificationAction('Supplier Updated! Pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* updateAuthApplicant({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const respone = yield call(api.updateAuthApplicant, payload);
    // yield put(updateAuthSupplierSuccessAction)
    yield put(newSuccessNotificationAction('Applicant Updated! Pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}
function* updateAuthCustomer({ payload }) {
  try {
    yield put(setAuthIsLoadingAction(true));
    const respone = yield call(api.updateAuthCustomer, payload);
    // yield put(updateAuthCustomerSuccessAction)
    yield put(newSuccessNotificationAction('Customer Updated! Pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

function* loadTokenFromStorage() {
  // const cachedToken = localStorage.getItem('TOKEN');
  const cachedToken = Cookie.get('TOKEN');
  // const cachedToken = 'testing value';
  try {
    yield put(setAuthIsLoadingAction(true));

    // added if statment
    const response = yield call(api.getCurrentUser);
    const { data } = response;
    yield put(loginUserSuccessAction(data, cachedToken));
  } catch (error) {
    yield console.log(error);
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401 &&
      cachedToken
    ) {
      // some code
      yield put(errorNotificationFromError(error));
      yield put(logoutUserAction());
    }
  } finally {
    yield put(setAuthIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.SIGNUP_ADMIN, signupAdmin);
  yield takeLatest(actions.SIGNUP_ARTISAN, signupArtisan);
  yield takeLatest(actions.SIGNUP_CUSTOMER, signupCustomer);
  yield takeLatest(actions.SIGNUP_SUPPLIER, signupSupplier);
  yield takeLatest(actions.FORGOT_PASSWORD, forgotPassword);
  yield takeLatest(actions.LOGIN_USER, loginUser);
  yield takeLatest(actions.LOGOUT_USER, logoutUser);
  yield takeLatest(actions.RESET_PASSWORD, resetPassword);
  yield takeLatest(globalActions.APP_READY, loadTokenFromStorage);
  yield takeLatest(actions.UPDATE_AUTH_ARTISAN, updateAuthArtisan);
  yield takeLatest(actions.UPDATE_AUTH_SUPPLIER, updateAuthSupplier);
  yield takeLatest(actions.UPDATE_AUTH_APPLICANT, updateAuthApplicant);
  yield takeLatest(actions.UPDATE_AUTH_CUSTOMER, updateAuthCustomer);
  yield takeLatest(actions.AUTH_UPDATE_USER_SETTINGS, updateUserSettings);
  yield takeLatest(actions.AUTH_UPDATE_USER, updateUser);
}
